import { makeApiRequest } from "./api-client";
import { NetworkingLayerConfig } from "./config";
import { createQueryRequestDefinitions } from "./definitions/create";
import { queryRequester } from "./requester";

export function createNetworkingLayer<DelegatedErrorParams = unknown>(
  config: NetworkingLayerConfig
) {
  const definitions = createQueryRequestDefinitions<DelegatedErrorParams>(config);

  return {
    ...definitions,
    makeApiRequest: makeApiRequest.bind(null, config),
    queryRequester: queryRequester.bind(null, config),
  };
}
